import React from 'react';
import './notes.scss';
function Note({ openModal, title, children, className, modalIsOpen }) {
  return (
    <div className='Note_Leaf'>
      <div onClick={openModal} className={`note ${className} ${modalIsOpen ? 'stuck' : ''}`}>
        {title}
      </div>
      {children}
    </div>
  );
}

export default Note;
